/* eslint-disable no-restricted-syntax */

export type QsNull = undefined | null;
export type QsNonNull = boolean | number | string;
export type QsArray = ReadonlyArray<QsGeneric>;
export type QsObject = {[key: string]: QsGeneric};
export type QsGeneric = QsNull | QsNonNull | QsArray | QsObject;

const {hasOwnProperty} = Object.prototype;

function qsNull(value: QsNull, prefix: string, buffer: string[]) {
  if (value === undefined) {
    // `undefined` does not serialize the parameter at all.
  } else if (value === null) {
    buffer.push(`${encodeURIComponent(prefix)}`);
  }
}

function qsNonNull(value: QsNonNull, prefix: string, buffer: string[]) {
  buffer.push(`${encodeURIComponent(prefix)}=${encodeURIComponent(value)}`);
}

function qsArray(value: QsArray, prefix: string, buffer: string[]) {
  const length = value.length;

  for (let key = 0; key < length; key++) {
    if (hasOwnProperty.call(value, key)) {
      const item = value[key];

      if (item == null || typeof item !== 'object') {
        qsGeneric(item, `${prefix}[]`, buffer);
      } else {
        qsGeneric(item, `${prefix}[${key}]`, buffer);
      }
    }
  }
}

function qsObject(value: QsObject, prefix: string, buffer: string[]) {
  for (const key in value) {
    if (hasOwnProperty.call(value, key)) {
      qsGeneric(value[key], `${prefix}[${key}]`, buffer);
    }
  }
}

function qsGeneric(value: QsGeneric, prefix: string, buffer: string[]) {
  if (value == null) {
    qsNull(value, prefix, buffer);
  } else if (Array.isArray(value) || value instanceof Array) {
    qsArray(value, prefix, buffer);
  } else if (typeof value === 'object') {
    qsObject(value, prefix, buffer);
  } else {
    qsNonNull(value, prefix, buffer);
  }
}

export default function stringify(value: QsObject): string {
  const buffer: string[] = [];

  for (const key in value) {
    if (value.hasOwnProperty(key)) {
      qsGeneric(value[key], key, buffer);
    }
  }

  return buffer.join('&');
}
